import { CreatableSearchSelect } from "./CreatableSearchSelect";
import { SearchSelectVirtualized } from "./SearchSelectVirtualized";

export const CreatableSearchSelectVirtualized = props => <CreatableSearchSelect {...props} SearchSelectComponent={SearchSelectVirtualized} />;
